import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const RefundAndCancellation = () => {

  return (<>

    {/*  <ComponenetHeader
      name={'Refund And Cancellation'}
    /> */}

    <section className="content_page text-left">
      <div className="container">
        <div className="row content_page_style justify-content-center">
          <div className="col-md-12">
           <h2 className="mb-4">Refund and Cancellation Policy</h2>
            <h3>Cancellation Policy</h3>
            <ul>
              <li>Customers may request cancellation of a service within fifteen (15) days from the date of signing the service agreement.</li>
              <li>Services purchased under promotional or discounted offers are non-cancellable and non-refundable, as these are limited-time deals.</li>
              <li>All payments made are non-refundable, even if a cancellation request is submitted within twelve (12) hours of purchase.</li>
              <li>If a scheduled payment is not received within seven (7) working days, the service will be automatically discontinued.</li>
            </ul>

            <h3>Refund Policy</h3>
            <ul>
              <li>Refund requests must be submitted within fifteen (15) days from the date of purchase.</li>
              <li>No refunds will be provided for services that have already been partially or fully completed, as operational resources are assigned in advance.</li>
              <li>Administrative costs, setup or installation fees, and any applicable government taxes are strictly non-refundable.</li>
              <li>Refunds will not be granted if a service is terminated due to a breach of our Terms and Conditions.</li>
              <li>Towing 411 shall not be held liable for refunds arising from delays, interruptions, or issues caused by third-party service providers.</li>
            </ul>

          </div>
        </div>
      </div>
    </section>
  </>
  );
};

export default RefundAndCancellation;